import { baseApi } from './base';
import type { AuditLogSearchParams, AuditLogListResponse } from '@/types/audit';

export const auditService = {
  async getAuditLogs(params: AuditLogSearchParams): Promise<AuditLogListResponse> {
    const queryParams: Record<string, string> = {};
    if (params.limit) queryParams.limit = params.limit.toString();
    if (params.offset) queryParams.offset = params.offset.toString();
    if (params.ordering) queryParams.ordering = params.ordering;
    if (params.search) queryParams.search = params.search;
    if (params.user) queryParams.user = params.user;
    if (params.action) queryParams.action = params.action;
    if (params.model_name) queryParams.model_name = params.model_name;
    if (params.object_id) queryParams.object_id = params.object_id;
    if (params.timestamp__range) queryParams.timestamp__range = params.timestamp__range;

    const query = new URLSearchParams(queryParams).toString();
    return baseApi.request<AuditLogListResponse>(`/audit-logs/?${query}`);
  },
};
